<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AS67">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="JANUARY 6: Called—and Empowered">
<h1 class="chapter2" id="pAXW"><a href="#/contents#AB_ch07" id="AB_cha07">JANUARY 6<br/> <br/> <span class="chapter2a">Called—and Empowered</span></a></h1>
<blockquote>
<p class="ext" id="pAoJ"><em>“Go, and I will . . . teach you what you shall say.”</em></p>
</blockquote>
<p class="right" id="pA7ar">—Exodus 4:12</p>
<p class="noind" id="Al9"><span class="dcap"><b>A</b></span>ny parent, anyone interviewing for a job, any teacher, any pastor, perhaps anyone on this planet can thank God that when He calls us to do something, He empowers us to do it.</p>
<p id="pAq-">Though Moses protested, “I am not eloquent . . . I am slow of speech and slow of tongue” (Exodus 4:10), in today’s verse we see God specifically promising that He will help Moses and tell him what to say to Pharaoh.</p>
<p id="pAh9V">God’s power is available to us, but receiving it requires faith. We must open ourselves to receive His promises. God gave Moses a specific promise for a specific situation, but rather than responding in faith, Moses said to God, “O my Lord, please send by the hand of whomever else You may send” (v. 13).</p>
<p id="pAjn">God granted Moses’ request and bestowed his brother, Aaron, with the ability, strength, and words to speak to Pharaoh. We miss out if, like Moses, we ask God to find someone else to do what He has called us to do. We are blessed when we, like Aaron, yield ourselves to God’s plan, open ourselves to His power, and experience His using us in His kingdom work.</p>
<p class="left1" id="pAqh_"><em>Thank You, Lord, for assigning certain tasks and roles to me. When I hesitate to obey, help me rally my courage to forge ahead.</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter07.vue?ef6d4c50